import { Box, Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLoad } from "../../context";
import ApiServices from "../../services/apiServices";
import Mask from "../../services/mask";
import storage from "../../services/storage";
import CloseIcon from "@mui/icons-material/Close";
import Carregando from "../../assets/images/svgs/loading.svg";
import "./index.css";
import DuploFator from "../../Components/DuploFator";
import { Link, useLocation } from "react-router-dom";
export default function TransferenciaPontos() {
  const location = useLocation();
  const [user] = useState(storage.get("USUARIO")?.loginResponse);
  const [beneficiarios, setBeneficiarios] = useState([]);
  const [beneficiariosTransferencia, setBeneficiariosTransferencia] = useState(
    []
  );
  const [meusPontos, setMeusPontos] = useState([]);
  const [totalPontos, setTotalPontos] = useState(0);
  const [tipoModal, setTipoModal] = useState(0);
  const [mostrar, setMostrar] = useState(false);
  const [verificaAntes, setVerificaAntes] = useState(true);
  const [verificaFechamento, setVerificaFechamento] = useState(null);
  const [abrirDuploFator, setAbrirDuploFator] = useState(false);
  const [tokenAcesso, setTokenAcesso] = useState("");
  const { load, setLoad } = useLoad();

  async function fnTransferencia() {
    setMostrar(false);
    var objEnvio = user.profile.cpenCli;
    try {
      setLoad(true);
      let response = await ApiServices.apiGet(
        "transferencia-pontos/" + objEnvio
      );

      response.data?.beneficiarios?.map((e, i) => {
        response.data.beneficiarios[i].nomeDe = e.nomeBeneficiario;
      });

      setBeneficiarios(response.data.beneficiarios);
      setMeusPontos(response.data);
      toast.error(response.statusCode != 200 && response.message);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
      setMostrar(true);
    }
  }
  async function fnTransferirAgora() {
    setTipoModal(2);
    var bene = beneficiariosTransferencia.filter((e) => e.pontos > 0);

    var objEnvio = {
      codiCli: user.profile.codiCli,
      nomePara: user.profile.nome,
      beneficiarios: bene,
      CodigoDuploFator: tokenAcesso,
    };

    try {
      setLoad(true);
      let response = await ApiServices.apiPost("transferir-pontos", objEnvio);
      if (response.statusCode == 200) {
        setAbrirDuploFator(false);
        toast.success("Transferência realizada com sucesso!");
      } else {
        setAbrirDuploFator(false);
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setTipoModal(0);
      setLoad(false);
      setBeneficiariosTransferencia([]);
      fnTransferencia();
    }
  }

  function fnTransferenciaPontos(e, i) {
    setBeneficiariosTransferencia([]);

    beneficiarios.map((ee, ii) => {
      if (ii == i) {
        if (e > ee.pontos) {
          setBeneficiariosTransferencia((prev) => [
            ...prev,
            { ...beneficiarios[ii], pontos: Number(ee.pontos) },
          ]);
        } else {
          setBeneficiariosTransferencia((prev) => [
            ...prev,
            { ...beneficiarios[ii], pontos: Number(e) },
          ]);
        }
      } else {
        setBeneficiariosTransferencia((prev) => [
          ...prev,
          {
            ...beneficiarios[ii],
            pontos: Number(
              beneficiariosTransferencia[ii]?.pontos
                ? beneficiariosTransferencia[ii]?.pontos
                : 0
            ),
          },
        ]);
      }
    });
  }

  useEffect(() => {
    var total = 0;
    beneficiariosTransferencia.map(
      (e, i) => (total = total + Number(e.pontos))
    );

    setTotalPontos(total);
  }, [beneficiariosTransferencia]);
  useEffect(() => {
    fnTransferencia();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  function transformarNumero(numero) {
    var raw = numero.replace(/[^a-zA-Z0-9]/g, "");
    if (/[a-zA-Z]/.test(raw) || raw.length === 14) {
      // CNPJ (alfanumérico ou numérico): mostra 2 primeiros e 2 últimos
      return raw.slice(0, 2) + ".***.***/****-" + raw.slice(12, 14);
    } else if (raw.length === 11) {
      return raw.replace(/(\d{3})\d{6}(\d{2})/, "$1.***.***-$2");
    } else {
      return numero;
    }
  }

  useEffect(() => {}, [beneficiarios]);
  useEffect(() => {
    if (tokenAcesso != "") {
      fnTransferirAgora();
    }
  }, [tokenAcesso]);
  // useEffect(() => {
  //   if (abrirDuploFator) {
  //     fnTransferirAgora();
  //   }
  // }, [abrirDuploFator]);
  return (
    <>
      {abrirDuploFator && (
        <DuploFator
          setAbrirDuploFator={setAbrirDuploFator}
          setTokenAcesso={setTokenAcesso}
          setVerificaAntes={setVerificaAntes}
          setVerificaFechamento={setVerificaFechamento}
        />
      )}


      <div className="d-flex justify-content-center extratoContainer">
        <div className="container mx-5 px-5">
          <div className="menuNavegacaoExtrato">
            <div className="headerExtrato">
              <div className="subMenuExtratoLinks">
                <Link
                  to="/extrato/meus-pontos"
                  className={location.pathname === "/extrato/meus-pontos" ? "ativo" : ""}
                >
                  EXTRATO
                </Link>
                <Link
                  to="/transferencia-de-pontos"
                  className={location.pathname === "/transferencia-de-pontos" ? "ativo" : ""}
                >
                  TRANSFERÊNCIA DE PONTOS
                </Link>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <h2>Recebimento de Pontos</h2>
            <div className="d-flex mt-3 mb-4">
              <p style={{ maxWidth: 700, fontSize: "16px", color: "#555" }}>
                Aqui você poderá transferir pontos dos participantes do grupo
                para sua conta! Esta ação ficará registrada nos extratos do
                grupo.
              </p>
            </div>
          </div>
          {mostrar ? (
            <div>
              <div className="row mb-4">
                <div className="col-lg-4">
                  <div className="cardExtract cardGrupo">
                    <div>
                      <div>{meusPontos.nomeGrupo || ""}</div>
                      <div className="tracoExtrato"></div>
                      <div style={{ marginTop: "12px", fontSize: "14px" }}>
                        Grupo: <b>{meusPontos.cpenCli}</b>
                      </div>
                    </div>
                    <div className="valorExtrato" style={{ fontSize: "28px" }}>
                      {meusPontos.pontos ? (
                        Mask.numeroPontos(meusPontos.pontos)
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 100 100"
                          preserveAspectRatio="xMidYMid"
                        >
                          <circle
                            cx="50"
                            cy="50"
                            r="32"
                            strokeWidth="8"
                            stroke="#000"
                            strokeDasharray="50.26548245743669 50.26548245743669"
                            fill="none"
                            strokeLinecap="round"
                          >
                            <animateTransform
                              attributeName="transform"
                              type="rotate"
                              repeatCount="indefinite"
                              dur="1s"
                              keyTimes="0;1"
                              values="0 50 50;360 50 50"
                            />
                          </circle>
                        </svg>
                      )}
                    </div>
                    <div style={{ fontSize: "14px", marginTop: "8px", fontWeight: "500" }}>
                      Você possui
                    </div>
                  </div>
                </div>
              </div>
              <table className="tableTransferencia">
                <thead>
                  <tr>
                    <th className="transferenciaCabecalho">CPF / CNPJ</th>
                    <th className="transferenciaCabecalho">Descrição</th>
                    <th className="transferenciaCabecalho" style={{ textAlign: "right" }}>Pontos</th>
                    <th className="transferenciaCabecalho" style={{ textAlign: "center" }}>Transferência</th>
                    <th className="transferenciaCabecalho" style={{ textAlign: "center" }}>Pontos para receber</th>
                  </tr>
                </thead>

                <tbody>
                  {beneficiarios && beneficiarios.length > 0 ? (
                    beneficiarios.map((e, i) => (
                      <tr key={i}>
                        <td className="transferenciaLinha">{transformarNumero(e.cpfCnpj.toString())}</td>
                        <td className="transferenciaLinha">{e.nomeDe}</td>
                        <td className="transferenciaLinha" style={{ textAlign: "right" }}>
                          {Math.trunc(beneficiarios[i].pontos -
                            (beneficiariosTransferencia[i]?.pontos
                              ? beneficiariosTransferencia[i]?.pontos
                              : 0))}
                        </td>
                        <td className="transferenciaLinha">
                          <div className="d-flex justify-content-center align-items-center">
                            {!storage.get("gestaoMenu")?.transferenciaPontos &&
                            <input
                              className="inputRangeTransferencia"
                              disabled={e.pontos <= 0}
                              type="range"
                              step={1}
                              max={e.pontos}
                              min={0}
                              value={
                                beneficiariosTransferencia[i]?.pontos
                                  ? beneficiariosTransferencia[i]?.pontos
                                  : 0
                              }
                              onChange={(v) => {
                                fnTransferenciaPontos(v.target.value, i);
                              }}
                            />}
                          </div>
                        </td>
                        <td className="transferenciaLinha">
                          <div className="d-flex justify-content-center align-items-center">
                            {!storage.get("gestaoMenu")?.transferenciaPontos && <input
                              className="inputQuantidadeTransferencia"
                              type="text"
                              value={
                                beneficiariosTransferencia[i]?.pontos
                                  ? beneficiariosTransferencia[i]?.pontos
                                  : 0
                              }
                              onChange={(v) => {
                                fnTransferenciaPontos(
                                  Mask.number(v.target.value),
                                  i
                                );
                              }}
                            />}
                          </div>
                        </td>

                        {/* <td>
                          {beneficiariosTransferencia[i]?.pontos
                            ? beneficiariosTransferencia[i]?.pontos
                            : 0}
                        </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="transferenciaLinha" style={{ textAlign: "center", padding: "40px 20px" }}>
                        <div style={{ fontSize: "16px", color: "#666" }}>
                          Você não possui ninguém disponível para fazer transferência de pontos no momento.
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>

                <tfoot>
                  <tr>
                    <td className="transferenciaLinha" colSpan="3"></td>
                    <td className="transferenciaLinha" style={{ fontWeight: "bold", textAlign: "right", paddingRight: "20px" }}>
                      Total de pontos:
                    </td>
                    <td className="transferenciaLinha" style={{ fontWeight: "bold", color: "#1a5940", textAlign: "center", fontSize: "16px" }}>
                      {totalPontos}
                    </td>
                  </tr>
                </tfoot>
              </table>
              <div className="row d-flex justify-content-center mt-4 mb-4">
                <div className="col-md-3 mt-3">
                  <button
                    className="btn btn-secondary btn-lg"
                    style={{ width: "100%", padding: "12px" }}
                    onClick={() => {
                      setBeneficiariosTransferencia([]);
                    }}
                  >
                    VOLTAR
                  </button>
                </div>
                <div className="col-md-3 mt-3">
                  {!storage.get("gestaoMenu")?.transferenciaPontos && <button
                    disabled={totalPontos <= 0}
                    className="btn btn-warning btn-lg"
                    style={{ 
                      width: "100%", 
                      padding: "12px",
                      backgroundColor: "#ffed00",
                      color: "#000",
                      fontWeight: "700",
                      border: "none"
                    }}
                    onClick={() => {
                      setTipoModal(1);
                    }}
                  >
                    RECEBER
                  </button>}
                </div>
              </div>
              <Modal
                keepMounted
                open={tipoModal != 0}
                onClose={() => setTipoModal(0)}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
              >
                <Box className="configModal">
                  <div className="d-flex justify-content-end pointer">
                    <CloseIcon onClick={() => setTipoModal(0)} />
                  </div>
                  {tipoModal == 1 && (
                    <Typography
                      id="keep-mounted-modal-title"
                      variant="h6"
                      component="h6"
                      textAlign={"center"}
                    >
                      Tem certeza que deseja transferir?
                      <div className="my-3">
                        Você receberá: {totalPontos} Pontos
                      </div>
                      <div className="my-3">
                        Após a transferência, os pontos terão validade de 30
                        dias.
                      </div>
                    </Typography>
                  )}
                  {tipoModal == 2 && (
                    <Typography
                      id="keep-mounted-modal-title"
                      variant="h6"
                      component="h2"
                      textAlign={"center"}
                    >
                      Transferindo pontos ...
                      <br />
                      <img src={Carregando} alt="caregando" />
                    </Typography>
                  )}
                  {tipoModal == 1 && (
                    <div className="row d-flex justify-content-between mt-5">
                      <div className="col-5">
                        <button
                          className="btn btn-danger"
                          onClick={() => {
                            setTipoModal(0);
                          }}
                        >
                          Cancelar
                        </button>
                      </div>
                      <div className="col-5">
                        <button
                          className="btn btn-success"
                          onClick={() => {
                            setTipoModal(0);
                            setAbrirDuploFator(true);
                          }}
                        >
                          Confirmar
                        </button>
                      </div>
                    </div>
                  )}
                </Box>
              </Modal>
            </div>
          ) : (
            <div className="d-flex flex-column align-items-center m-5">
              <p style={{ fontSize: "16px", color: "#666", marginBottom: "20px" }}>
                Carregando informações do grupo...
              </p>
              <img src={Carregando} alt="caregando" />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
